import { render, staticRenderFns } from "./SliceUploadGuide.vue?vue&type=template&id=7fc60c32&scoped=true"
import script from "./SliceUploadGuide.vue?vue&type=script&lang=js"
export * from "./SliceUploadGuide.vue?vue&type=script&lang=js"
import style0 from "./SliceUploadGuide.vue?vue&type=style&index=0&id=7fc60c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc60c32",
  null
  
)

export default component.exports